import { DisabledPrompt, useWorkflowStep } from 'bcms-react';
import { CenterContentContainer, ContentHeaderView, PageContentView, TableBody, TableColumnContainer, TableColumnView, TableItemContainer, TableItemTextView, TableView } from 'components/shared';
import PageContainer from 'components/shared/containers/PageContainer';
import React from 'react';
import "./styles.css";
import UserActivityWorkflow, { getDefault, getWorkflowSteps } from 'components/workflows/UserActivityWorkflow';

/**
 * @function UserActivityPage
 * @return {React.Component}
 * @exported true
 * @description The main component for UserActivityPage
 */
export default function UserActivityPage(props) {
  const workflowStep = useWorkflowStep(getDefault, getWorkflowSteps);
  const userActivities = workflowStep.read("userActivities");
  const rows = userActivities.reduce((acc, activity) => {
    acc.push(
      <UserActivityTableRow key={ activity.id } activity={ activity } />
    );
    return acc;
  }, []);

  return (
    <PageContainer className="user-activity-page">
        <PageContentView>
          <CenterContentContainer>
            <ContentHeaderView text="User Activity" />
            <TableView>
              <TableColumnContainer>
                <TableColumnView className="text-left" text="Date" />
                <TableColumnView className="text-left" text="Action" />
              </TableColumnContainer>
              <TableBody>
                { rows }
              </TableBody>
            </TableView>

            {/* Pagination */}
            <div className="pagination flex-container flex-horizontal all-center">
              <DisabledPrompt>
                <div className="previous-button-container flex-container flex-horizontal align-center set-width clickable">
                  &#60;
                  <p className="pagination-words">Prev</p>
                </div>
              </DisabledPrompt>
              <div className="numbers-container flex-container flex-horizontal align-center set-width">
                <p className="selected set-width clickable">1</p>
                <DisabledPrompt>
                  <p className="set-width clickable">2</p>
                </DisabledPrompt>
                <DisabledPrompt>
                  <p className="set-width clickable">3</p>
                </DisabledPrompt>
              </div>
              <DisabledPrompt>
                <div className="next-button-container flex-container flex-horizontal align-center set-width clickable">
                  <p className="pagination-words">Next</p>
                  &#62;
                </div>
              </DisabledPrompt>
            </div>
          </CenterContentContainer>
        </PageContentView>
    </PageContainer>
  )
}

/**
 * @function UserActivityTableRow
 * @return {React.Component}
 * @exported false
 * @description The row for the User Activity Table
 */


function UserActivityTableRow(props) {
  const activity = props.activity ?? {};
  const category = activity.category ?? { description: "logged in" };
  
  // In this component, "logged in" is formatted as "Logged in".
  let categoryFormatted = category.description.split(" ");
  let firstWord = categoryFormatted[0].charAt(0).toUpperCase();
  categoryFormatted = firstWord + categoryFormatted[0].substring(1) + " " + categoryFormatted[1];

  return (
    <TableItemContainer>
      <TableItemTextView text={ `${ activity.date.format('m/d/Y') } ${ activity.time }` } />
      <TableItemTextView text={ categoryFormatted } />
    </TableItemContainer>
  );
}